import axios from "axios";
import moment from "moment";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SignatureImage from "../assets/images/9705b85baa92bcc6ac85822185369656.png";
import {
  OPEN_SIGNATURE_MODAL,
  REMOVE_SIGNATURE,
} from "../redux/actions/actionTypes";
import {
  UPDATE_ADMIN_FORM,
  UPDATE_ADMIN_FORM_ERROR,
} from "../redux/actions/formActions";
import CustomButton from "./Button";
import SignatureComponent from "./Signature";
import { sendSuccessToast, showErrorToast } from "../utils/toast";
import {
  apiKey,
  frontendApp,
  frontendAppUrl,
  serverBaseUrl,
} from "../config/envs";
import { useParams } from "react-router-dom";
import { isWhitespaceString } from "../utils/regex";

const GFEForm = ({
  signImage,
  data,
  isFirstSign,
  filledSignatureIds,
  setFilledSignatureIds,
}) => {
  const { signSecretId } = useParams();
  const dispatch = useDispatch();
  const adminFormData = useSelector((state) => state?.form?.adminForm);
  const adminFormErrors = useSelector((state) => state?.form?.adminFormErrors);

  const singnerData = useSelector((state) => state?.signature?.signerData);
  const signature = useSelector((state) => state?.signature);
  const { loading } = signature;
  let currentIndex = 0;
  const [currentDate, setCurrentDate] = useState(
    `${new Date().toLocaleDateString("en-US")} ${new Date().toLocaleTimeString(
      "en-US"
    )}`
  );

  const handleOnSignatureClick = useCallback(() => {
    if (signImage) {
      if (isFirstSign) {
        setFilledSignatureIds([...filledSignatureIds, "signature_1"]);
        handleChangeError("signature_1", null);
      } else {
        setFilledSignatureIds([...filledSignatureIds, "signature_3"]);
        handleChangeError("signature_3", null);
      }
    } else {
      dispatch({
        type: OPEN_SIGNATURE_MODAL,
      });
      if (isFirstSign) {
        setFilledSignatureIds([...filledSignatureIds, "signature_1"]);
        handleChangeError("signature_1", null);
      } else {
        setFilledSignatureIds([...filledSignatureIds, "signature_3"]);
        handleChangeError("signature_3", null);
      }
    }
  }, [signature, filledSignatureIds, isFirstSign, signImage]);

  const removeSignature = async (file) => {
    let _payLoad = {
      signerId: data.data?.signers[0]?.id,
      clinicId: data?.data?.qualiphy_clinic_id,
      signSecretId: data?.data?.sign_secret_id,
    };
    dispatch({
      type: REMOVE_SIGNATURE,
      payload: _payLoad,
    });
  };

  const handleChangeForm = (e) => {
    dispatch({
      type: UPDATE_ADMIN_FORM,
      payload: { key: e.target.name, value: e.target.value },
    });
  };

  const handleChangeError = (key, value) => {
    dispatch({
      type: UPDATE_ADMIN_FORM_ERROR,
      payload: { key, value },
    });
  };
  useEffect(() => {
    dispatch({
      type: UPDATE_ADMIN_FORM,
      payload: {
        key: "title",
        value: "Authorized Signatory",
      },
    });
  }, []);

  useEffect(() => {
    if (data?.data?.qualiphy_clinic_name) {
      dispatch({
        type: UPDATE_ADMIN_FORM,
        payload: {
          key: "name_of_practice",
          value: data?.data?.qualiphy_clinic_name,
        },
      });
    }
    if (data?.data?.signers[0]?.name) {
      dispatch({
        type: UPDATE_ADMIN_FORM,
        payload: {
          key: "admin_name",
          value: data?.data?.signers[0]?.name,
        },
      });
    }
  }, [data]);

  useEffect(() => {
    if (
      adminFormErrors &&
      Object.entries(adminFormErrors).filter(([key, value]) => value != null)
        .length
    ) {
      // scroll to the first error
      const firstError = Object.keys(adminFormErrors)[0];
      const element = document.getElementById(firstError);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [adminFormErrors]);

  const [submitLoading, setSubmitLoading] = useState(false);

  const handleSubmit = useCallback(async () => {
    if (isFirstSign) return;

    if (!filledSignatureIds.includes("signature_1")) {
      handleChangeError("signature_1", "Please sign the document");
      showErrorToast("Please fill all the required fields");
      return;
    } else {
      handleChangeError("signature_1", null);
    }
    if (!filledSignatureIds.includes("signature_2")) {
      handleChangeError("signature_2", "Please sign the document");
      showErrorToast("Please fill all the required fields");
      return;
    } else {
      handleChangeError("signature_2", null);
    }
    if (!filledSignatureIds.includes("signature_3")) {
      handleChangeError("signature_3", "Please sign the document");
      showErrorToast("Please fill all the required fields");
      return;
    } else {
      handleChangeError("signature_3", null);
    }

    if (
      !adminFormData?.name_of_practice ||
      isWhitespaceString(adminFormData?.name_of_practice)
    ) {
      handleChangeError(
        "name_of_practice",
        "Please enter your name of practice"
      );
      showErrorToast("Please fill all the required fields");
      return;
    } else {
      handleChangeError("name_of_practice", null);
    }
    if (
      !adminFormData?.admin_name ||
      isWhitespaceString(adminFormData?.admin_name)
    ) {
      handleChangeError("admin_name", "Please enter your name");
      showErrorToast("Please fill all the required fields");
      return;
    } else {
      handleChangeError("admin_name", null);
    }
    if (!adminFormData?.title || isWhitespaceString(adminFormData?.title)) {
      handleChangeError("title", "Please enter your title");

      return;
    } else {
      handleChangeError("title", null);
    }

    setSubmitLoading(true);
    const formData = new FormData();
    formData.append("qualiphy_clinic_id", data?.data?.qualiphy_clinic_id);
    formData.append("sign_link_id", data?.data?.signers[0]?.sign_link_id);
    formData.append("sign_secret_id", data?.data?.sign_secret_id);
    formData.append("document_type", "1");
    formData.append("signer_id", data?.data?.signers[0]?.id);
    formData.append("sign_link", data?.data?.sign_link);
    formData.append("signature", signImage);
    formData.append("dateSigned", moment(currentDate).format("MM-DD-YYYY"));
    formData.append("qualiphy_president", "John Doe");
    formData.append("qualiphy_president_role", "President");
    formData.append("clinic_name", adminFormData?.name_of_practice?.trim());
    formData.append("signer_name", adminFormData?.admin_name?.trim());
    formData.append("signer_role", adminFormData?.title?.trim());
    formData.append("signer_date", moment(currentDate).format("MM-DD-YYYY"));

    try {
      const response = await axios.post(
        `${serverBaseUrl}/submit_document`,
        formData,

        {
          headers: {
            "sign-secret-id": signSecretId,
          },
        }
      );

      if (response?.data?.success === true) {
        window.location.href = frontendAppUrl;
      } else {
        showErrorToast("Something went wrong, please try again later");
      }
    } catch (err) {
      showErrorToast("Something went wrong, please try again later");
      console.log(err);
    } finally {
      setSubmitLoading(false);
    }
  }, [singnerData, adminFormData, filledSignatureIds]);

  return (
    <div className="my-4">
      <div className="w-full px-4 flex flex-col md:flex-row justify-between gap-4">
        <div className="w-1/2 flex flex-col gap-2">
          {!isFirstSign ? (
            <p className="text-justify mb-1.5">
              <span className="font-serif text-base">
                (“Business Associate”)
              </span>
            </p>
          ) : (
            <></>
          )}
          <b>Qualiphy PC: </b>
          <div>
            <img
              src={SignatureImage}
              name="Image2"
              align="left"
              width={200}
              height={50}
              border={0}
              className="mb-2" // Optional: Adds margin-bottom to create space between image and border
            />
          </div>

          <div className="western text-justify">
            <label htmlFor="date-signed" className="block font-bold mb-2">
              By:
            </label>
            Robert Vichich, M.D.
          </div>

          <div className="western text-justify">
            <label htmlFor="date-signed" className="block font-bold mb-2">
              Title:
            </label>
            President
          </div>
          <div className="western text-justify">
            <label htmlFor="date-signed" className="block font-bold mb-2">
              Date:
            </label>
            {currentDate}
          </div>
        </div>
        <div className="w-full md:w-1/2">
          <p className="text-justify mb-1.5">
            <span className="font-serif  text-base">
              {!isFirstSign ? (
                <>(“Covered Entity”)</>
              ) : (
                <>
                  <b>PRACTICE</b>
                </>
              )}
            </span>
          </p>
          <div
            id={isFirstSign ? "signature" : "signature3"}
            className="flex flex-col gap-3 western mb-4"
          >
            <div className="w-full">
              <label
                id="name_of_practice"
                htmlFor="date-signed"
                className="block font-bold mb-2 truncate"
              >
                Name of Practice:
              </label>
              <input
                type="text"
                id={isFirstSign ? "name_of_practice_1" : "name_of_practice_3"}
                name="name_of_practice"
                value={adminFormData?.name_of_practice}
                onChange={(e) => handleChangeForm(e)}
                className="border border-gray-300 rounded p-2 w-full "
              />
              {
                adminFormErrors?.name_of_practice && (
                  <span className="text-red-500 text-sm error-message">
                    {adminFormErrors?.name_of_practice}
                  </span>
                ) // Optional: Display error message if name_of_practice is empty
              }
            </div>
            <div className="w-full">
              {signImage &&
              filledSignatureIds.includes(
                isFirstSign ? "signature_1" : "signature_3"
              ) ? (
                <SignatureComponent
                  allButtonIds={[
                    "signature_1",
                    "signature_2",
                    "signature_3",
                    "submit",
                  ]}
                  handleOnSignatureClick={handleOnSignatureClick}
                  loading={loading}
                  removeSignatures={removeSignature}
                  userSignauter={signImage}
                  id={isFirstSign ? "signature_1" : "signature_3"}
                />
              ) : null}
              {!signImage ||
              !filledSignatureIds.includes(
                isFirstSign ? "signature_1" : "signature_3"
              ) ? (
                <CustomButton
                  className="px-4"
                  labelColor="black"
                  label="Sign"
                  id={isFirstSign ? "signature_1" : "signature_3"}
                  onClick={() =>
                    handleOnSignatureClick({ type: "adminPracticeSign" })
                  }
                />
              ) : null}
              {
                isFirstSign && adminFormErrors?.signature_1 && (
                  <span className="text-red-500 text-sm error-message">
                    {adminFormErrors?.signature_1}
                  </span>
                ) // Optional: Display error message if signature is empty
              }
              {
                !isFirstSign && adminFormErrors?.signature_3 && (
                  <span className="text-red-500 text-sm error-message">
                    {adminFormErrors?.signature_3}
                  </span>
                ) // Optional: Display error message if signature is empty
              }
            </div>
          </div>

          <div className="western text-justify">
            <label
              htmlFor="date-signed"
              className="block font-bold mb-2"
              id="admin_name"
            >
              By:
            </label>
            <input
              type="text"
              id={isFirstSign ? "admin_name_1" : "admin_name_3"}
              name="admin_name"
              value={adminFormData?.admin_name}
              onChange={(e) => handleChangeForm(e)}
              className="border border-gray-300 rounded p-2 w-full "
            />
            {
              adminFormErrors?.admin_name && (
                <span className="text-red-500 text-sm error-message">
                  {adminFormErrors?.admin_name}
                </span>
              ) // Optional: Display error message if admin_name is empty
            }
          </div>
          <div className="western text-justify">
            <label
              id="title"
              htmlFor="date-signed"
              className="block font-bold mb-2"
            >
              Title:
            </label>
            <input
              type="text"
              id={isFirstSign ? "title_1" : "title_3"}
              name="title"
              value={adminFormData?.title}
              onChange={(e) => handleChangeForm(e)}
              className="border border-gray-300 rounded p-2 w-full "
            />
            {
              adminFormErrors?.title && (
                <span className="text-red-500 text-sm error-message">
                  {adminFormErrors?.title}
                </span>
              ) // Optional: Display error message if title is empty
            }
          </div>
          <div className="western text-justify">
            <label
              id="date-signed"
              htmlFor="date-signed"
              className="block font-bold mb-2"
            >
              Date Signed:
            </label>
            <input
              type="text"
              name="date_signed"
              id="date-signed"
              value={currentDate}
              disabled
              className="border border-gray-300 rounded p-2 w-full "
            />
          </div>
        </div>
      </div>
      {!isFirstSign ? (
        <div className="w-full flex justify-end mt-4">
          <CustomButton
            label="Submit"
            labelColor="black"
            backgroundColor={"rgb(207 201 255)"}
            className="w-full sm:w-auto"
            onClick={handleSubmit}
            id="submit"
            isLoading={submitLoading}
          />
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default GFEForm;
